export enum TipoMovimentoTrabalhadorEnum {
	DEPARTAMENTO = 0,
    ESTABELECIMENTO = 1,
    LOTACAO = 2,
    EMPRESA = 3,
    TRABALHADOR = 4,
    SINDICATO = 5,
    CARGO = 6
}
